import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Grid, makeStyles } from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import Button from "../../components/CustomButtons/Button";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import { toCamelCase } from "utils/Utils";
import ToastModal from "views/components/ToastModal";
import BottomButton from "components/UpdateUi/BottomButton/BottomButton";
import { mandateStatusList } from "assets/properties/properties";
const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    margin: "0 auto",
    minHeight: "85vh",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1, // Allows content to expand and scroll
    overflowY: "auto", // Enables scrolling inside content
    paddingBottom: theme.spacing(2), // Avoids content cutting off at bottom
  },
  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
  },
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1100px",
  },
  fieldContaienr: {
    margin: "2% 2% 0px 0px",
    maxWidth: "31.3%",
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "10% 2% 0px 2%",
    },
  },
  emptyState: {
    textAlign: "center",
    padding: "20px",
    borderRadius: "8px",
    width: "100%",
    marginTop: "20px",
  },

  emptyMessage: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#333",
  },

  emptySubMessage: {
    fontSize: "14px",
    color: "#666",
    marginBottom: "10px",
  },

  createButton: {
    marginTop: "10px",
    background: "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
    textTransform: 'capitalize',
    color: "#fff",
    "&:hover": {
      backgroundColor: "#15191e",
    },
  },
}));

const MandateDetails = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const currentLead = useSelector((state) => state.login.userCurrentLead);
  const { leadId } = currentLead;
  const [data, setData] = useState({});
  const [callInProgress, setCallInProgress] = useState(false);
  const [mandateData, setMandateData] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [isMandateInProgress, setIsMandateInProgress] = useState(false);
  const [isMandatePending, setIsMandatePending] = useState(false);
  const authData = useSelector((state) => state.login.authData);
  const { authToken } = authData;
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  console.log(currentLead,)
  // const persistMandateSession = () => {
  //   localStorage.setItem("authToken", authToken);
  //   localStorage.setItem("leadId", leadId);
  // };

  useEffect(() => {
    if (leadId) {
      fetchLoanSummary();
      // persistMandateSession();
    }
  }, [leadId, authData, currentLead]);

  const fetchLoanSummary = async (skipAuthRedirect = false) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.USER_FIND_MANDATE_DETAILS_API + leadId,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code ) {
      if(skipAuthRedirect){
      toastUpdate("Error", result?.data?.user_description, true);
      }
      setMandateData(false);
      setIsMandatePending(false);
    } 
    const state = result?.data?.mandateState;
  
    if (mandateStatusList?.inprogress?.includes(state)) {
      if (!skipAuthRedirect && result?.data?.authUrl) {
        openHtmlInNewTab(result?.data?.authUrl);
      }
      setMandateData(false);
      setIsMandatePending(true);
    } else 
      if (mandateStatusList?.success.includes(state)) {
      setData(result?.data);
      setMandateData(true);
      setIsMandatePending(false);
    } else 
      if (
      mandateStatusList?.failed?.includes(state)
    ) 
    {
      toastUpdate("Error", `Mandate failed.`, true);
      setMandateData(false);
      setIsMandatePending(false);
    }
    return result;
  };

  const startMandatePolling = () => {
  setIsMandateInProgress(true);

  const intervalId = setInterval(async () => {
    const summaryResult = await fetchLoanSummary(true);
    if (
      summaryResult?.data &&
      !summaryResult?.data?.error_code &&
      mandateStatusList?.success?.includes(
        summaryResult?.data?.mandateState
      )
    ) {
      setCallInProgress(false);
      clearInterval(intervalId);
      clearTimeout(timeoutId);
      setIsMandateInProgress(false);
      setIsMandatePending(false);
    }else if (
      mandateStatusList?.failed?.includes(
        summaryResult?.data?.mandateState
      )
    ){
      toastUpdate("Error", "Mandate authorization failed. Please try again.", true);
      setCallInProgress(false);
      clearInterval(intervalId);
      clearTimeout(timeoutId);
      setIsMandateInProgress(false);
      setIsMandatePending(false);
    }
  }, 30000); // Poll every 30 seconds
  const timeoutId = setTimeout(() => {
    clearInterval(intervalId);
    setIsMandateInProgress(false);
        setCallInProgress(false);
    setIsMandatePending(false);
    console.log("Polling stopped after 5 minutes.");
  }, 5 * 60 * 1000); // 5 minutes
};

 const createMandateDetails = async () => {
  setCallInProgress(true);

  const result = await apiHandler({
    url: endpoint.USER_CREATE_MANDATE_DETAILS_API,
    method: "POST",
    authToken,
    data: {
      leadApplicationId: leadId,
    },
  });
  if (result?.data?.error_code) {
    toastUpdate("Error", result?.data?.user_description, true);
    setCallInProgress(false);
    return;
  }

  if (result?.data?.htmlPayload) {
    const win = window.open("", "_blank");
    win.document.open();
    win.document.write(result.data.htmlPayload);
    win.document.close();
    startMandatePolling();
  } else if (result?.data?.authUrl) {
    openHtmlInNewTab(result?.data?.authUrl);
    startMandatePolling();
  }
};

  const openHtmlInNewTab = (url) => {
    window.open(url);
  };

  const handleNext = async () => {
    navigate("/journey/DisbursalDetails");
  };
  const isMandateValid = () => {
    return (
      mandateData &&
      mandateStatusList?.success?.includes(data?.mandateState)
    );
  };
  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <SubHeader
          label="Mandate Details"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          {mandateData ? (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.fieldContaienr}
              >
                <CustomTextField
                  label="Mandate Id"
                  placeholder="Loan Account Number"
                  value={data?.mandateId}
                  style={classes.inputField}
                  disabled={true}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.fieldContaienr}
              >
                <CustomTextField
                  label="Mandate State"
                  value={toCamelCase(data?.mandateState)}
                  style={classes.documentSelectBox}
                  disabled={true}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.fieldContaienr}
              >
                <CustomTextField
                  label="Max Amount"
                  value={data?.maxAmount}
                  style={classes.documentSelectBox}
                  disabled={true}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.fieldContaienr}
              >
                <CustomTextField
                  label="Customer Account Number"
                  value={data?.customerAccountNumber}
                  style={classes.documentSelectBox}
                  disabled={true}
                />
              </Grid>
            </>
          ) : isMandatePending ? (
            <Grid
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
              className={classes.emptyState}
            >
              <p className={classes.emptyMessage}>Mandate creation in progress...</p>
              <p className={classes.emptySubMessage}>
                Please complete the authorization in the new browser tab or via the link sent to your mobile phone.
              </p>
            </Grid>
          ) : (
            <Grid
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
              className={classes.emptyState}
            >
              <p className={classes.emptyMessage}>Mandate Details Not Present.</p>
              <p className={classes.emptySubMessage}>
                Click the button below to create mandate details.
              </p>
              <Button
                color="primary"
                onClick={createMandateDetails}
                className={classes.createButton}
              >
                Create Mandate
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <BottomButton
          button1={"Next"}
          button1click={handleNext}
          disabled1={!isMandateValid()}
        />
      </Grid>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </Grid>
  );
};

export default MandateDetails;
